import { render, staticRenderFns } from "./CreateSGInstanceProfiles.vue?vue&type=template&id=f638ec2c"
import script from "./CreateSGInstanceProfiles.vue?vue&type=script&lang=js"
export * from "./CreateSGInstanceProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports